export const SIDEBAR_CONSTANTS = {
  labels: {
    SIGN_IN: 'Sign In',
    OR: 'or',
    CREATE_NEW_ACCOUNT: 'CREATE NEW ACCOUNT',
    NEW_POST: 'New Post',
    HOME: 'Home',
    FEED: 'Feed',
    ACTIVITY: 'Activity',
    MESSAGES: 'Messages',
    CREATORS: 'Creators',
    MONETIZE: 'Monetize',
    WALLET: 'Wallet',
    INSIGHTS_AND_FANS: 'Insights & Fans'
  },
  alt: {
    TOPFAN_LOGO: 'TopFan Logo',
    LOGO: 'Logo'
  }
} as const;
